<script>
  import { Chart, Loading, Notification } from '../components';
  import { getAllMacroHistory } from '../api.js';
  
  async function load() {
    document.title = "History";

    let result = await getAllMacroHistory();
    let data = result.data;
    data.sort(historyCompare);

    let total = [];
    for (let i = 0; i < data.length; i++) {
      total.push(data[i].CountStockGe50 + data[i].CountStockLt50);
    }

    return { time: data.map(x => x.UnixTimeSeconds), total: data.map(x => x.CountStockGe50 + x.CountStockLt50), good: data.map(x => x.CountStockGe50), bad: data.map(x => x.CountStockLt50) };
  }

  function historyCompare(a, b) {
    if ( a.UnixTimeSeconds < b.UnixTimeSeconds ) return -1;
    if ( a.UnixTimeSeconds > b.UnixTimeSeconds ) return 1;
    return 0;
  }
</script>

{#await load()}
  <Loading visible />
{:then data}
  <div class="chart-container">
    <Chart {data} />
  </div>
{:catch error}
  <Notification icon="error" message={error.message} visible />
{/await}

<style>
  .chart-container {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
</style>

